import { ApolloError } from "@apollo/client";

import { WorkbenchDiffStatus } from "../../../workbench/state/diffStatus";
import { ContextWorkbenchChangesetFragment } from "../../queries/useInitContextWorkbenchChangeset.generated";
import { ContextWorkbenchState } from "../contextWorkbenchState";
import { contextWorkbenchPublishSelectors } from "../selectors/publishSelectors";

export type InitPublishChangesetPayload = {
  data: ContextWorkbenchChangesetFragment | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
};

export function initPublishChangeset(
  state: ContextWorkbenchState,
  payload: InitPublishChangesetPayload,
): void {
  const { data, error, loading } = payload;
  state.publish.changeset = {
    loading: loading,
    error: error,
    value: data ?? undefined,
    loadId: data?.id ?? state.publish.changeset.loadId,
  };

  // auto-select the first changed file
  if (data && !state.publish.selectedFileId) {
    const files = contextWorkbenchPublishSelectors.selectFiles({
      contextWorkbench: state,
    });
    state.publish.selectedFileId =
      files.find((f) => f.diff.status !== WorkbenchDiffStatus.UNMODIFIED)?.id ??
      files[0]?.id ??
      null;
  }
}
